import {
  ALL_SLOTS,
  MYSTERY_IDS,
  SLOT_WEIGHT,
  VARIANTS_PER_SLOT,
  type ClueSlot,
  type ClueTemplate,
  type MysteryDefinition,
  type MysteryId,
} from './types';

/**
 * Die moeglichen Aufloesungen.
 *
 * Hinweise werden nicht einzeln von Hand angelegt, sondern nach fester
 * Konvention erzeugt: Jede Aufloesung bekommt fuer jeden Slot genau so viele
 * Varianten, wie das Skelett im ungünstigsten Fall verlangt. Die Texte selbst
 * liegen im Uebersetzungskatalog unter `clue.<aufloesung>.<slot>.<n>`.
 *
 * Der Vorteil: Es kann keine Aufloesung geben, der ein Slot fehlt — und ein
 * fehlender Text faellt sofort im Katalogtest auf, nicht erst im Spiel.
 */

function buildClues(mystery: MysteryId): ClueTemplate[] {
  const clues: ClueTemplate[] = [];

  for (const slot of ALL_SLOTS) {
    for (let index = 1; index <= VARIANTS_PER_SLOT[slot as ClueSlot]; index++) {
      clues.push({
        id: `${mystery}.${slot}.${index}`,
        mystery,
        slot,
        textKey: `clue.${mystery}.${slot}.${index}`,
        weight: SLOT_WEIGHT[slot],
      });
    }
  }

  return clues;
}

export const MYSTERY_DEFINITIONS: readonly MysteryDefinition[] = MYSTERY_IDS.map((id) => ({
  id,
  nameKey: `mystery.${id}`,
  revelationKey: `mystery.${id}.revelation`,
  clues: buildClues(id),
}));

export function mysteryDefinition(id: MysteryId): MysteryDefinition {
  const found = MYSTERY_DEFINITIONS.find((m) => m.id === id);
  if (found === undefined) {
    throw new Error(`Unbekannte Auflösung: ${id}`);
  }
  return found;
}

/** Alle Hinweisvorlagen einer Aufloesung fuer einen bestimmten Slot. */
export function cluesForSlot(mystery: MysteryId, slot: ClueSlot): readonly ClueTemplate[] {
  return mysteryDefinition(mystery).clues.filter((c) => c.slot === slot);
}
